var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#28673C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9498 7.5C20.9498 7.22386 20.7259 7 20.4498 7H18.2498C17.056 7 15.9118 7.47676 15.0682 8.31351C14.2236 9.16 13.7498 10.3032 13.7498 11.5V14.2H11.5498C11.2737 14.2 11.0498 14.4239 11.0498 14.7V17.3C11.0498 17.5761 11.2737 17.8 11.5498 17.8H13.7498V24.5C13.7498 24.7761 13.9737 25 14.2498 25H16.8498C17.1259 25 17.3498 24.7761 17.3498 24.5V17.8H20.4498C20.7259 17.8 20.9498 17.5761 20.9498 17.3V14.7C20.9498 14.4239 20.7259 14.2 20.4498 14.2H17.3498V11.5C17.3498 11.2568 17.4442 11.032 17.6135 10.8608C17.7818 10.6992 18.0114 10.6 18.2498 10.6H20.4498C20.7259 10.6 20.9498 10.3761 20.9498 10.1V7.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1eb8be9cf5027b40649a6fc3c0274721.svg";
export { ForwardRef as ReactComponent };